import React from 'react';
import RotatingText from './RotatingText';
import './Clients.css';

const Clients = () => {
  const clients = [
    { name: 'Pizza Hut', logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/mxB4Gjwo2Xh7OnGZ/pizzahutlogo-AR0LQveDDqI99qPn.jpg' },
    { name: 'Wayback Burgers', logo: 'https://assets.zyrosite.com/mxB4Gjwo2Xh7OnGZ/wayback_burgers_logo-m5KM46PZXDSWGD0a.svg' },
    { name: 'Which Wich', logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/mxB4Gjwo2Xh7OnGZ/whichwichlogo-mjE7OpzXKrukJxQJ.png' },
    { name: 'Gloria Jeans', logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/mxB4Gjwo2Xh7OnGZ/gloriajeanslogo-m2W8yz12NecnbPKk.webp' },
    { name: 'Mex Cafe', logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/mxB4Gjwo2Xh7OnGZ/mexcafebreakfast-YrDWkp3ME4IBlDP8.webp' },
    { name: 'Classic Bar', logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/mxB4Gjwo2Xh7OnGZ/classicbarandloungelogo-YBg7JnEvX2fWVaRJ.webp' },
    { name: 'Shell', logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/mxB4Gjwo2Xh7OnGZ/shellgasstationlogo-AMq15L29g5tpOl0G.png' },
    { name: 'Karate International', logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=264,fit=crop/mxB4Gjwo2Xh7OnGZ/karateinternationallogoticker-A3Q23EgaL9fkeGDv.png' },
    { name: 'The Flying Biscuit', logo: '/flying-biscuit-logo.png' },
  ];

  const duplicatedClients = [...clients, ...clients];

  return (
    <section className="clients-section">
      <div className="clients-container">
        <h2 className="clients-title">
          <span className="fixed-text">Trusted by Leading Businesses</span>
          
        </h2>
        <p className="clients-subtitle">Partnering with businesses to automate reservations, calls, and customer engagement.</p>
        <div className="clients-carousel">
          <div className="clients-track">
            {duplicatedClients.map((client, index) => (
              <div key={index} className="client-card">
                <img
                  src={client.logo}
                  alt={client.name}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;